// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetOrderbook (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetTickerCurrency (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    publicGetOhlc (params?: {}): Promise<Dict>;
    publicGetServerExchangeinfo (params?: {}): Promise<Dict>;
    privateGetUsersBalances (params?: {}): Promise<Dict>;
    privateGetOpenOrders (params?: {}): Promise<Dict>;
    privateGetAllOrders (params?: {}): Promise<Dict>;
    privateGetOrderOrderId (params?: {}): Promise<Dict>;
    privateGetUsersTransactionsTrade (params?: {}): Promise<Dict>;
    privateGetUsersTransactionsCrypto (params?: {}): Promise<Dict>;
    privateGetUsersTransactionsFiat (params?: {}): Promise<Dict>;
    privateGetCryptoDepositDeclarations (params?: {}): Promise<List>;
    privatePostUsersTransactionsCrypto (params?: {}): Promise<Dict>;
    privatePostUsersTransactionsFiat (params?: {}): Promise<Dict>;
    privatePostOrder (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCryptoDepositDeclarationsConfirm (params?: {}): Promise<Dict>;
    privateDeleteOrder (params?: {}): Promise<Dict>;
    graphGetOhlcs (params?: {}): Promise<List>;
    graphGetKlinesHistory (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
